import { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'

export default function useBootstrapData() {
  return useContext(BootstrapDataContext)
}
